import { ReactComponent as Home } from "assets/svgs/Home.svg";
import { ReactComponent as UserAccounts } from "assets/svgs/User-Accounts.svg";

import { ReactComponent as Graph } from "assets/svgs/Graph.svg";
// import { ReactComponent as Layers } from "assets/svgs/Layers.svg";
import { ReactComponent as Settings } from "assets/svgs/Settings.svg";
// import { ReactComponent as Store } from "assets/svgs/Store.svg";
import { ReactComponent as Bank } from "assets/svgs/Bank.svg";
import { Routes } from "routes/routes";
// import OrderCounter from "components/OrderCounter";

export type SubRoute = {
  link: string;
  name: string;
  badge?: number | string | JSX.Element;
}
export interface AppRoutesType {
  id: number;
  path: string;
  label: string;
  icon?: any;
  element?: React.LazyExoticComponent<React.FC<{}>> | any;
  subRoutes?: Array<SubRoute>;
}

// readonly array for all app routes
const appRoutes: AppRoutesType[] = [
  {
    id: 1,
    path: Routes.dashboard,
    label: "Dashboard",
    icon: Home,
  },
  {
    id: 2,
    path: Routes.transactions,
    label: "Transactions",
    icon: Graph,
    subRoutes: [
      {
        link: Routes.transactionsPayment,
        name: "Payments",
      },
      {
        link: Routes.transactionsRefunds,
        name: "Refunds",
      },
      {
        link: Routes.transactionsChargeBack,
        name: "Chargebacks",
      },
    ],
  },
  {
    id: 3,
    path: Routes.customers,
    label: "Customers",
    icon: UserAccounts,
  },
  {
    id: 4,
    path: Routes.transfers,
    label: "Transfers",
    icon: Bank,
    subRoutes: [
      {
        link: Routes.transfersRemittance,
        name: "Transfers",
      },
      // {
      //   link: Routes.transfersInvoices,
      //   name: "Invoices",
      // },
      {
        link: Routes.recipients,
        name: "Recipients",
      },
      {
        link: Routes.transfersPaymentLinks,
        name: "Payment Links",
      },
    ],
  },
  // {
  //   id: 5,
  //   path: Routes.subAccounts,
  //   label: "Sub Accounts",
  //   icon: Layers,
  // },
  // {
  //   id: 6,
  //   path: Routes.storefronts,
  //   label: "Storefronts",
  //   icon: Store,
  //   subRoutes: [
  //     {
  //       link: Routes.manageStorefronts,
  //       name: "Manage Store",
  //     },
  //     // {
  //     //   link: Routes.storefrontProducts,
  //     //   name: "Products",
  //     // },
  //     {
  //       link: Routes.storefrontOrders,
  //       name: "Orders",
  //       badge: <OrderCounter/>,
  //     },
  //   ],
  // },
  {
    id: 7,
    path: Routes.settings,
    label: "Settings",
    icon: Settings,
  },
];

export default appRoutes;
